import { createSlice } from '@reduxjs/toolkit'


const InitState = {
        name:'',
        email:'',
        password:'',
        status:undefined,
        access_level:undefined,
        isEdit:false
}

export const userSlice  = createSlice({
    name:'user',
    initialState : {
        userState:InitState
    },
    reducers:{
        addUserState:(state,action)=>{
            state.userState[action.payload.name] = action.payload.value
        },
        editsubAdmin: (state, action) => {
            state.userState = action.payload
        },
        stateRefresh: (state, action) => {
            state.userState = InitState
        },
    },
})

export const { addUserState,editsubAdmin,stateRefresh } = userSlice.actions

export default userSlice.reducer   